export const GET_specifyExternalEmployeeByUser = ({ external_employees }) => (user_id) => {
  return external_employees.filter((external_employee) => {
    return external_employee.user_id === user_id
  })
}

export const GET_specifyExternalEmployee = ({ external_employees }) => (external_employee_id) => {
  return external_employees.filter((external_employee) => {
    return external_employee.id === external_employee_id
  })
}
